import BillingsOrderRelatedRailyTaxiRequest from "../../../../../api/raily/billings/order/related/raily-taxi/billings-order-related-raily-taxi.request";
import BillingsOrderRelatedRailyTaxiParams from "./billings-order-related-raily-taxi-params";

const createRequest = (
  params: BillingsOrderRelatedRailyTaxiParams,
): BillingsOrderRelatedRailyTaxiRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const billingsOrderRelatedRailyTaxiParamsFactory = {
  createRequest,
};

export default billingsOrderRelatedRailyTaxiParamsFactory;
